import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import DoeModal from "@/components/modal/Modal";
import { serviceCallWithAuth } from "@/helpers/cognito";

export default {
  methods: {
    ...mapActions(["SAVE_FIELD"]),
    updateState(statementData) {
      this.SAVE_FIELD(statementData);
    },
    createModal(headline, description, label) {
      var ComponentClass = Vue.extend(DoeModal);
      var instance = new ComponentClass({
        propsData: {
          headline: headline,
          description: description,
          label: label
        }
      });
      instance.$mount();
      // instance.$slots.default = ['Click me!']
      document.getElementById("app").appendChild(instance.$el);
      return instance;
    },
    destroyModal(instance) {
      instance.$el.parentNode.removeChild(instance.$el);
      instance.$destroy();
    },
    statementData(statementUuid) {
      return this.getStatmentByUuid(statementUuid);
    },
    actionSend($event) {
      this.$router.push({
        name: "statement-send-to-another",
        params: { statementUuid: $event.uuid }
      });
    },
    actionDelete($event) {
      let UUIDs = [];
      if ($event.uuid) {
        UUIDs.push($event.uuid);
      } else {
        UUIDs = this.$root.selectedItems;
      }
      let m = this.$root.translateMessage({
        code: "DeleteStatement",
        message:
          `You're about to permanently delete ${UUIDs.length===1 ? '1 statement': UUIDs.length + ' statements'}, and all of the information provided.
          Press Delete to confirm deletion or press Cancel.
          `,
        title: "Delete statement?"
      });
      m.button = "Delete";
      m.cancellable = true;
      const that = this;

      m.action = () => {
        that.$root.isLoading = true;
        let headers = this.$OAuth.buildHttpHeader();

        let pList = [];
        UUIDs.forEach(uuid => {
          let p = serviceCallWithAuth("doe-ttss", {
            path: "storage/" + uuid,
            method: "PUT",
            searchParams: {
              delete: true
            },
            headers: headers
          }).then(item => {
            that.$store.commit("SAVE_STATEMENT", item.Item);
          });
          pList.push(p);
        });

        Promise.all(pList)
          .catch(err => {
            // console.log( err);

            that.$root.translateModal(err, "Error");

            if (err.navigate) {
              that.$router.push({
                name: err.navigate,
                params: { saved: false }
              });
            }
          })
          .then(() => {
            // console.log( "LOAD ALL");
            return serviceCallWithAuth("doe-ttss", {
              path: "/storage",
              searchParams: {
                ConsistentRead: false
              },
              headers: headers
            });
          })
          .then(result => {
            // console.log( result);
            that.$store.commit("CLEAR_STATEMENTS", result);
            that.$root.selectedItems = [];
            that.$root.scanRequired = false;
          })
          .finally(function() {
            that.$root.isLoading = false;
            var aa = document.querySelectorAll("input[type=checkbox]");
            for (var i = 0; i < aa.length; i++) {
              aa[i].checked = false;
            }
          });
      };

      this.$root.showModal(m);
    },
    actionArchive($event) {
      // console.log( "THIS", this);
      // console.log( "EVENT", $event);

      let UUIDs = [];
      if ($event.uuid) {
        UUIDs.push($event.uuid);
      } else {
        UUIDs = this.$root.selectedItems;
      }

      let m = this.$root.translateMessage({
        code: "ArchiveStatement",
        message:
          "You're about to archive this statement, and all of the information provided.",
        title: "Archive statement?"
      });
      m.button = "Archive";
      m.cancellable = true;
      const that = this;
      let headers = this.$OAuth.buildHttpHeader();

      m.action = () => {
        that.$root.isLoading = true;

        let pList = [];
        UUIDs.forEach(uuid => {
          let p = serviceCallWithAuth("doe-ttss", {
            path: "storage/" + uuid,
            method: "PUT",
            searchParams: {
              archive: true
            },
            headers: headers
          }).then(item => {
            that.$store.commit("SAVE_STATEMENT", item.Item);
          });
          pList.push(p);
        });

        Promise.all(pList)
          .then(() => {
            // console.log( result);
            return serviceCallWithAuth("doe-ttss", {
              path: "/storage",
              searchParams: {
                ConsistentRead: false
              },
              headers: headers
            });
            // return p;
          })
          .then(result => {
            // console.log( result);
            that.$store.commit("CLEAR_STATEMENTS", result);
            that.$root.selectedItems = [];
            that.$root.scanRequired = false;
          })
          .catch(err => {
            // console.log( err);

            that.$root.translateModal(err, "Error");

            if (err.navigate) {
              that.$router.push({
                name: err.navigate,
                params: { saved: false }
              });
            }
          })
          .finally(function() {
            that.$root.isLoading = false;
            var aa = document.querySelectorAll("input[type=checkbox]");
            for (var i = 0; i < aa.length; i++) {
              aa[i].checked = false;
            }
          });
      };

      this.$root.showModal(m);
    },
    actionDownload($event) {
      // console.log( JSON.stringify( $event,  null, 2));
      // let statementData = this.statementData($event.uuid);
      if ($event.uuid) {
        let that = this;
        that.$root.isLoading = true;
        let headers = this.$OAuth.buildHttpHeader();

        serviceCallWithAuth("doe-ttss", {
          path: `/generate/${$event.uuid}`,
          headers: headers
        })
          .then(result => {
            let url = result.url;
            // console.log( "open", url);
            window.open(url, "_blank");
          })
          .finally(function() {
            that.$root.isLoading = false;
            var aa = document.querySelectorAll("input[type=checkbox]");
            for (var i = 0; i < aa.length; i++) {
              aa[i].checked = false;
            }
          });
      }
    },
    actionUnarchive($event) {
      let vm=this;
      let UUIDs = [];
      if ($event.uuid) {
        UUIDs.push($event.uuid);
      } else {
        UUIDs = this.$root.selectedItems;
      }
      const currentCohortYear = vm.getRefData.currentCohortYear.ece;
      if (currentCohortYear) {
        UUIDs = UUIDs.filter(uuid => {
          const data = vm.$store.getters.getStatmentByUuid(uuid);
          return data && data.cohortYear && parseInt(data.cohortYear) === parseInt(currentCohortYear)
        });
      }
      if (UUIDs.length === 0) {
        return this.$root.translateModal(
          `Only statements for children transitioning to school in ${currentCohortYear} can be made live. 
          None of the statements you selected belong to ${currentCohortYear} cohort year. 
          To continue, please select at least one statement from the ${currentCohortYear} cohort year.`,
          "Error"
        );
      }
      let m = this.$root.translateMessage({
        code: "UnArchiveStatement",
        message: `Only statements for children transitioning to school in ${currentCohortYear} can be made live. You are about to unarchive ${
          UUIDs.length === 1 ? "1 statement" : UUIDs.length + " statements"
        } and all of the information provided. Any selected statements from previous years will remain archived.`,
        title: `Unarchive ${UUIDs.length === 1 ? "statement" : "statements"}?`
      });

      m.button = "Unarchive";
      m.cancellable = true;
      const that = this;
      let headers = this.$OAuth.buildHttpHeader();

      m.action = () => {
        that.$root.isLoading = true;

        let pList = [];
        UUIDs.forEach(uuid => {
          let p = serviceCallWithAuth("doe-ttss", {
            path: "storage/" + uuid,
            method: "PUT",
            searchParams: {
              archive: false
            },
            headers: headers
          }).then(item => {
            that.$store.commit("SAVE_STATEMENT", item.Item);
          });
          pList.push(p);
        });

        Promise.all(pList)
          .then(() => {
            // console.log( result);
            return serviceCallWithAuth("doe-ttss", {
              path: "/storage",
              searchParams: {
                archive: true,
                ConsistentRead: false
              },
              headers: headers
            });
          })
          .then(result => {
            // console.log( result);
            that.$store.commit("CLEAR_STATEMENTS", result);
            that.$root.selectedItems = [];
            that.$root.scanRequired = false;
          })
          .catch(err => {
            // console.log( err);

            that.$root.translateModal(err, "Error");

            if (err.navigate) {
              that.$router.push({
                name: err.navigate,
                params: { saved: false }
              });
            }
          })
          .finally(function() {
            that.$root.isLoading = false;
            var aa = document.querySelectorAll("input[type=checkbox]");
            for (var i = 0; i < aa.length; i++) {
              aa[i].checked = false;
            }
          });
      };

      this.$root.showModal(m);
    }
  },
  computed: {
    ...mapGetters(["getStatmentByUuid", "getRefData"])
  }
};
